import { create } from "zustand";

const usePopupMsg = create((set) => ({
  isOpen: false,
  msg: "",
  label: "", 
  open: (msg, label = "success") => set({ isOpen: true, msg, label }),
  close: () => set({ isOpen: false, msg: "", label: "" }),
}));

export default usePopupMsg;